import { createSelector } from '@reduxjs/toolkit';

import { sortBy } from '@paragon/utilities';

import { RootState } from '../store';
import { getDocuments } from './documents';

const getIndexMap = (state: RootState) => state.documentTools.indexMap;

export const getDocumentsAsSortedArrayFromIndexMap = createSelector(
  [getDocuments, getIndexMap],
  (documents, indexMap) => sortBy(documents, (document) => indexMap![document.id]),
);
